type graphics = "high" | "medium" | "low";

export type ViewMode = {
    size: "desktop" | "tabletHorizontal" | "tabletVertical" | "mobileHorizontal" | "mobileVertical",
    graphics: graphics
};

const GRAPHICS_MODE_HIGH_BORDER = 45;
const GRAPHICS_MODE_LOW_BORDER = 25;
const GRAPHICS_MODE_THRESHOLD = 5;
const DURATION_THRESHOLD = 1000;
const MAX_TIMES_CHANGED_TO_LOWER_QUALITY = 3;

let previousGraphicsMode: graphics;
let graphicsModeChangedTime: number = 0;
let timesChangedToMedium: number = 0;
let timesChangedToLow: number = 0;

export default function defineViewMode(fps?: number): ViewMode {
    const width = window.innerWidth;
    const height = window.innerHeight;
    let graphics: graphics;
    let size: "desktop" | "tabletHorizontal" | "tabletVertical" | "mobileHorizontal" | "mobileVertical";

    const currentTime = Date.now();

    if (fps) {
        if (!previousGraphicsMode) {
            if (fps >= GRAPHICS_MODE_HIGH_BORDER) graphics = 'high';
            else if (fps >= GRAPHICS_MODE_LOW_BORDER) graphics = 'medium';
            else graphics = 'low';
        }
        else if (
            (fps > GRAPHICS_MODE_HIGH_BORDER + GRAPHICS_MODE_THRESHOLD && !(previousGraphicsMode === 'high')) ||
            (fps < GRAPHICS_MODE_LOW_BORDER - GRAPHICS_MODE_THRESHOLD && !(previousGraphicsMode === 'low')) ||
            ((fps > GRAPHICS_MODE_LOW_BORDER + GRAPHICS_MODE_THRESHOLD || fps < GRAPHICS_MODE_HIGH_BORDER - GRAPHICS_MODE_THRESHOLD) && !(previousGraphicsMode === 'medium'))
        ) {
            if (graphicsModeChangedTime === 0) {
                graphicsModeChangedTime = currentTime;
                graphics = previousGraphicsMode;
            } else if (currentTime - graphicsModeChangedTime >= DURATION_THRESHOLD) {
                if (fps > GRAPHICS_MODE_HIGH_BORDER + GRAPHICS_MODE_THRESHOLD) {
                    if (timesChangedToMedium <= MAX_TIMES_CHANGED_TO_LOWER_QUALITY) graphics = 'high';
                    else graphics = 'medium';
                } else if (fps > GRAPHICS_MODE_LOW_BORDER + GRAPHICS_MODE_THRESHOLD) {
                    if (timesChangedToLow <= MAX_TIMES_CHANGED_TO_LOWER_QUALITY) {
                        if (previousGraphicsMode == 'high') timesChangedToMedium++;
                        graphics = 'medium';
                    } else graphics = 'low';
                } else {
                    timesChangedToLow ++;
                    graphics = 'low';
                }
                graphicsModeChangedTime = 0;
            } else {
                graphics = previousGraphicsMode;
            }
        } else {
            graphicsModeChangedTime = 0;
            graphics = previousGraphicsMode;
        }
    } else {
        graphics = 'low';
    }
    previousGraphicsMode = graphics;

    if (Math.max(width, height) < 900) { 
        if (width < height) size = 'mobileVertical';
        else size = 'mobileHorizontal';
    }
    else if (Math.max(width, height) <= 1024) {
        if (width < height) size = 'tabletVertical';
        else size = 'tabletHorizontal';
    }
    else size = 'desktop';

    return {graphics, size};
}